import { render, staticRenderFns } from "./ReCardTicketAdd.vue?vue&type=template&id=6b8633a0&scoped=true"
import script from "./ReCardTicketAdd.vue?vue&type=script&lang=js"
export * from "./ReCardTicketAdd.vue?vue&type=script&lang=js"
import style0 from "./ReCardTicketAdd.vue?vue&type=style&index=0&id=6b8633a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8633a0",
  null
  
)

export default component.exports